class PedagogicalService {
    constructor($http, $q) {
        this.$http = $http;
        this.$q = $q;
    };

    getAllSkills = () => {
        let self = this;
        return self.$http({
            method: 'GET',
            url: './api/subject_area',
            headers: {
                'Content-Type': 'application/json',
                'authentication': localStorage.getItem('kes_token')
            },
            data: {}
        })
        .then(function successCallback(response) {
            return response.data;
        },
        function errorCallback(response) {
            return self.$q.reject(response);
        });
    };

    getAllParameters() {
        let self = this;
        return self.$http({
            method: 'GET',
            url: '/api/pedagogical_approach',
            headers: {
                'Content-Type': 'application/json',
                'authentication': localStorage.getItem('kes_token')
            },
            data: {}
        })
        .then(function successCallback(response) {
            return response.data;
        },
        function errorCallback(response) {
            return self.$q.reject(response);
        });
    };

    updateQuestion(question) {
        let self = this;
        return self.$http({
            method: 'POST',
            url: `/api/pedagogical_approach${question.id ? `/${question.id}` : ''}`,
            data: question,
            headers: {
                'Content-Type': 'application/json',
                'authentication': localStorage.getItem('kes_token')
            }
        })
        .then(function successCallback(response) {
            return response.data;
        },
        function errorCallback(response) {
            return self.$q.reject(response);
        });
    };

    removeQuestion(question) {
        let self = this;
        return self.$http({
            method: 'DELETE',
            url: `/api/pedagogical_approach/${question.id}`,
            data: question.id,
            headers: {
                'Content-Type': 'application/json',
                'authentication': localStorage.getItem('kes_token')
            }
        })
        .then(function successCallback(response) {
            return response.data;
        },
        function errorCallback(response) {
            return self.$q.reject(response);
        });
    };
}

export default PedagogicalService;


// WEBPACK FOOTER //
// ./src/app/pages/manageSkills/services/pedagogicalService.js